var exports = {
  "k": "x61f99309--dab4a9--container",
};

module.exports = exports;
